import { type FormEvent, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { request } from "../lib/api";

export function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  return (
    <div className="auth-page">
      <aside className="auth-side">
        <Link to="/" className="brand" style={{ color: "#fff" }}>
          <img src="/logo.svg" alt="" width={44} height={44} />
          <div className="brand-text"><span>Marie Curie</span><small style={{ color: "rgba(255,255,255,.6)" }}>Platformă internă</small></div>
        </Link>
        <div>
          <h2>Resetează-ți parola în siguranță.</h2>
          <p>Vom trimite un link unic pe emailul tău. După ce îl deschizi, alegi o parolă nouă.</p>
        </div>
        <div />
      </aside>

      <main className="auth-main">
        <div className="auth-form">
          {token ? <ResetWithToken token={token} onSuccess={() => navigate("/login")} /> : <RequestReset />}
          <div style={{ textAlign: "center", marginTop: 18 }}>
            <Link to="/login" style={{ fontSize: ".9rem" }}>← Înapoi la autentificare</Link>
          </div>
        </div>
      </main>
    </div>
  );
}

function RequestReset() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState<{ text: string; kind: "info" | "success" | "error" } | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await request("/auth/forgot-password", { method: "POST", body: { email }, skipAuth: true });
      setMsg({ text: "Dacă adresa există, vei primi în curând un email cu instrucțiuni.", kind: "success" });
      setEmail("");
    } catch (err) {
      setMsg({ text: err instanceof Error ? err.message : "Eroare", kind: "error" });
    } finally {
      setSubmitting(false);
    }
  }
  return (
    <>
      <h1>Ai uitat parola?</h1>
      <span className="muted">Introdu emailul tău, îți trimitem un link de resetare.</span>
      <form onSubmit={onSubmit} style={{ marginTop: 24 }}>
        <div className="form-group">
          <label>Email</label>
          <input className="form-control" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        {msg && (
          <div style={{ padding: "10px 14px", borderRadius: 8, fontSize: ".88rem", marginBottom: 14,
            background: msg.kind === "success" ? "#e6f6ee" : msg.kind === "error" ? "#fde6eb" : "#e6f5f8",
            color: msg.kind === "success" ? "#0b6b46" : msg.kind === "error" ? "#a8092b" : "#00657b" }}>
            {msg.text}
          </div>
        )}
        <button className="btn btn-primary btn-lg btn-block" type="submit" disabled={submitting}>
          {submitting ? "Se trimite..." : "Trimite linkul"} <i className="fa-solid fa-paper-plane"></i>
        </button>
      </form>
    </>
  );
}

function ResetWithToken({ token, onSuccess }: { token: string; onSuccess: () => void }) {
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState<{ text: string; kind: "success" | "error" } | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (pw !== confirm) {
      setMsg({ text: "Parolele nu coincid.", kind: "error" });
      return;
    }
    setSubmitting(true);
    try {
      await request("/auth/reset-password", { method: "POST", body: { token, new_password: pw }, skipAuth: true });
      setMsg({ text: "Parolă schimbată! Te redirecționăm...", kind: "success" });
      setTimeout(onSuccess, 1500);
    } catch (err) {
      setMsg({ text: err instanceof Error ? err.message : "Token invalid", kind: "error" });
      setSubmitting(false);
    }
  }
  return (
    <>
      <h1>Setează o parolă nouă</h1>
      <span className="muted">Alege o parolă de minim 8 caractere.</span>
      <form onSubmit={onSubmit} style={{ marginTop: 24 }}>
        <div className="form-group"><label>Parolă nouă</label><input className="form-control" type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} /></div>
        <div className="form-group"><label>Confirmă parola</label><input className="form-control" type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} /></div>
        {msg && (
          <div style={{ padding: "10px 14px", borderRadius: 8, fontSize: ".88rem", marginBottom: 14,
            background: msg.kind === "success" ? "#e6f6ee" : "#fde6eb",
            color: msg.kind === "success" ? "#0b6b46" : "#a8092b" }}>
            {msg.text}
          </div>
        )}
        <button className="btn btn-primary btn-lg btn-block" type="submit" disabled={submitting}>
          {submitting ? "Se salvează..." : "Salvează parola"} <i className="fa-solid fa-check"></i>
        </button>
      </form>
    </>
  );
}
